import {useCallback, useEffect, useRef, useState} from 'react';
import {WrapperDiv, WrapperSection} from '../../../DetailsPage.styles';
import CustomCombo from './CustomCombo/CustomCombo';
import RecommendedCombo from './RecommendedCombo/RecommendedCombo';

const MultiRoom = ({
  handlOpenCalendar = () => {},
  hasOccupancyCombos = false,
  hasRecommendedCombos = false,
}) => {
  return (
    <WrapperSection>
      <WrapperDiv>
        {hasRecommendedCombos && <RecommendedCombo handlOpenCalendar={handlOpenCalendar} />}
        {hasOccupancyCombos && <CustomCombo />}
      </WrapperDiv>
    </WrapperSection>
  );
};
export default MultiRoom;
